import DraggableLabel from './DraggableLabel';

export default DraggableLabel;